import { PROCESS_TYPE_TRANSLATION_KEYS } from '../constants/processTypes';

/**
 * Find a translation key for a process name using case-insensitive matching.
 * Returns the translation key (value from PROCESS_TYPE_TRANSLATION_KEYS) or undefined.
 */
export const findProcessTranslationKeyInsensitive = (
  name?: string
): string | undefined => {
  if (!name) return undefined;
  // direct match first
  if (PROCESS_TYPE_TRANSLATION_KEYS[name])
    return PROCESS_TYPE_TRANSLATION_KEYS[name];
  const lowerName = name.toLowerCase();
  const matched = Object.keys(PROCESS_TYPE_TRANSLATION_KEYS).find(
    k => k.toLowerCase() === lowerName
  );
  return matched ? PROCESS_TYPE_TRANSLATION_KEYS[matched] : undefined;
};
